<template>
  <v-snackbar
    v-model="$store.state.snackbarOld"
    :timeout="20000"
    top
    color="red accent-2"
    class="bg-warning"
  >
    <strong>
      Nova Porudzbina (
      {{ $store.state.notification.length ? $store.state.notification[0].order_id : "" }}
      )
    </strong>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="primary"
        text
        v-bind="attrs"
        @click="$store.commit('SET_SNACKBAR', false)"
      >
        {{ $t("close") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { db } from "@/plugins/firebase";
export default {
  name: "OrderNotificationSnackbar",
  methods: {
    async getNotifications() {
      let todosRef = await db.collection("orders").orderBy("created_at", "desc");
      todosRef.onSnapshot((snap) => {
        this.$store.commit("SET_NOTIFICATION", []);
        snap.forEach((doc) => {
          let data = doc.data();
          data.id = doc.id;
          this.$store.commit("INCREASE_NOTIFICATION", data);
        });
        this.$store.commit("SET_SNACKBAR", true);
      });
    },
  },
};
</script>
